<template>
    <div class="wrapper">
        <template v-if="authenticated">
            <left-sidebar />
            <div id="content-page" class="content-page">
                <div class="content">
                    <topbar />

                    <router-view></router-view>
                </div>
                <!-- content -->
                <app-footer />
            </div>
        </template>
        <modal-manager ref="modalManager"></modal-manager>
        <transition name="fade">
            <login-modal v-if="showLoginModal"></login-modal>
        </transition>
    </div>
</template>

<script>
import { EventBus } from "@/utils/EventBus";
import { mapState } from "vuex";

import Topbar from "./components/Topbar";
import LeftSidebar from "./components/LeftSidebar";
import AppFooter from "./components/AppFooter";
import LoginModal from "./components/LoginModal";

import ModalManager from "./components/ModalManager";

export default {
    components: {
        Topbar,
        LeftSidebar,
        AppFooter,
        LoginModal,
        ModalManager
    },
    computed: {
        ...mapState("auth", {
            authenticated: state => state.authenticated,
            showLoginModal: state => state.showLoginModal
        })
    },
    methods: {
        showModal(type, params) {
            this.$refs.modalManager.showModal(type, params);
        },
        scrollToTop() {
            $("html,body").animate({
                scrollTop: 0
            });
        }
    },
    mounted() {
        EventBus.$on("show-modal", this.showModal);
        EventBus.$on("scroll-top", this.scrollToTop);
    },
    beforeDestroy() {
        EventBus.$off("show-modal", this.showModal);
        EventBus.$off("scroll-top", this.scrollToTop);
    }
};
</script>

<style lang="scss">
@import "@/scss/shared.scss";
@import "@/scss/client.scss";

.content-page {
    background-color: white;
}
</style>
